<template>
  <div class="tags-container" :key="path">
    <div class="tags">
      <a
        v-for="(tag, index) in visitedViews"
        :key="tag.path"
        :class="isActive(tag) ? 'active' : ''"
        @click="handleTagClick(tag)"
      >
        {{ tag.title }}
        <a-icon @click.stop="delTag(tag, index)" type="close-circle" />
      </a>
      <div @mouseenter="isDropShow = true" @mouseleave="isDropShow = false" v-show="hiddenTags.length > 0" style="position: relative; display: inline-block">
        <a-icon style="margin-left: 20px; color: #1890ff; cursor: pointer" type="down" />
        <ul v-show="isDropShow" class="dropdown">
          <li @click="resetHiddenTags">{{ $t('tagsClose') }}</li>
          <li v-for="(t, index) in hiddenTags" @click="handleClickHiddenTag(t)" :key="t.path">
            {{ t.title }}
            <a-icon @click.stop="delHiddenTag(t, index)" style="margin-left: 10px; color: #ccc" type="close-circle" theme="filled" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getMenusOfCurrentUser } from '@/api/auth/menu'

export default {
  props: {
    menus: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      isDropShow: false
    }
  },
  watch: {
    path(value) {
      const p = value.startsWith('/overview') ? '/overview' : value
      let m
      for (let i = 0; i < this.menus.length; i++) {
        if (this.menus[i].route === p) {
          m = this.menus[i]
          break
        } else if (this.menus[i].children && this.menus[i].children.length) {
          for (let j = 0; j < this.menus[i].children.length; j++) {
            if (this.menus[i].children[j].route === p) {
              m = this.menus[i].children[j]
              break
            }
          }
        }
      }
      if (m) {
        this.$store.commit('ADD_VISITED_VIEW', m)
        sessionStorage.setItem('authorities', JSON.stringify(m.authorities))
      }
    },
    lang(value) {
      const l = value === 'en' ? 'en-US' : 'zh-CN'
      this.visitedViews.forEach(v => {
        v.title = v.details.find(d => d.locale === l).name
      })
      this.hiddenTags.forEach(v => {
        v.title = v.details.find(d => d.locale === l).name
      })
      // this.$forceUpdate()
    }
  },
  computed: {
    path() {
      return this.$route.path
    },
    visitedViews() {
      return this.$store.state.visitedViews
    },
    hiddenTags() {
      return this.$store.state.hiddenTags
    },
    lang() {
      return this.$store.state.lang
    }
  },
  async mounted() {
    if (this.$route.fullPath !== '/') {
      const data = JSON.parse(localStorage.getItem('menus')) || []
      const index = data.findIndex(m => m.routeName === 'Overview')
      const route = data.splice(index, 1)
      const l = this.$store.state.lang === 'en' ? 'en-US' : 'zh-CN'
      data.unshift(route[0])
      if (this.$route.path.startsWith('/overview')) {
        route[0].name = route[0].details.find(d => d.locale === l).name
        this.$store.commit('ADD_VISITED_VIEW', route[0])
        sessionStorage.setItem('authorities', JSON.stringify(route[0].authorities))
        return
      }
      const menus = data
      let menu
      for (let i = 0; i < menus.length; i++) {
        if (menus[i].route === this.$route.fullPath) {
          menu = menus[i]
          break
        }
        if (menus[i].children) {
          for (let j = 0; j < menus[i].children.length; j++) {
            if (menus[i].children[j].route === this.$route.fullPath) {
              menu = menus[i].children[j]
            }
          }
        }
      }
      if (menu && (!menu.route.startsWith('/warning') || menu.route === '/warning' || menu.route === "/warning/order")) {
        menu.name = menu.details.find(d => d.locale === l).name
        this.$store.commit('ADD_VISITED_VIEW', menu)
        sessionStorage.setItem('authorities', JSON.stringify(menu.authorities))
      }
    }
  },
  methods: {
    isActive(route) {
      if (this.$route.path.startsWith('/overview')) {
        return route.route === '/overview'
      }
      if (this.$route.path.startsWith('/warning') && this.$route.path !== "/warning/order") {
        return route.route === '/warning'
      }
      return route.route === this.$route.path
    },
    delTag(tag, index) {
      this.$store.commit('DEL_VISITED_VIEW', tag)
      const vs = this.$store.state.visitedViews
      if (vs.length === 0) {
        this.$router.replace('/')
        return
      }
      if ((tag.route === this.$route.path) || (tag.route === '/overview' && this.$route.path.startsWith('/overview')) || (tag.route === '/warning' && this.$route.path.startsWith('/warning'))) {
        if (index === 0) {
          this.$router.push(vs[0].route)
        } else {
          this.$router.push(vs[index - 1].route)
        }
      }
    },
    delHiddenTag (tag, index) {
      this.$store.commit('DELHIDDENTAG', index)
    },
    resetHiddenTags() {
      this.$store.commit('resetHiddenTags')
    },
    findRoute(menus = []) {
      let menu = menus.find(i => i.route === this.$route.fullPath)
      if (menu) {
        return menu
      }

    },
    handleClickHiddenTag(tag) {
      this.$store.commit('ADD_VISITED_VIEW', tag)
      this.handleTagClick(tag)
    },
    handleTagClick(tag) {
      sessionStorage.setItem('authorities', JSON.stringify(tag.authorities))
      this.$router.push({ path: tag.route, query: tag.query })
    }
  }
}
</script>

<style lang="less" scoped>
.tags {
  padding-left: 10px;
  position: relative;
  a {
    display: inline-block;
    height: 100%;
    line-height: 64px;
    padding: 0 20px;
    font-size: 14px;
    color: #333;
    position: relative;
    i {
      position: absolute;
      right: 0;
      top: 14px;
      font-size: 12px;
      opacity: 0;
      color: #999;
    }
    &.active {
      color: #218ceb;
      border-bottom: 2px solid #218ceb;
    }
    &:hover {
      i {
        opacity: 1;
      }
    }
  }
}
.dropdown {
  width: auto;
  padding: 5px 0;
  position: absolute;
  background-color: #fff;
  z-index: 100;
  left: 20px;
  top: 46px;
  white-space: nowrap;
  box-shadow: 0 0 2px rgba(0, 0, 0, .3);
  li {
    padding: 6px 10px;
    margin: 0;
    list-style: none;
    line-height: normal;
    cursor: pointer;
    &:hover {
      background-color: #e6f7ff;
    }
  }
}
</style>